export default __webpack_public_path__ + "static/media/bio.b095039f.png";